<template>
  <wizard-panel name="qualification" :status="panels.qualification" @open="openPanel" @close="closePanel">
    <div class="wizard-panel__inner" v-if="panels.qualification === 1">
      <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
        <h2 v-html="qualification.name"></h2>

        <ul class="data-list">
          <li class="data-list__item">
            <section class="info">

              <form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
                <FormInfoHeader heading="Общая информация">
                  <div v-if="!mainInfoEditable">
                    <EditBtn v-if="!read"
                             @click.prevent="mainInfoEditable = true">
                      Редактировать
                    </EditBtn>
                  </div>
                  <div v-else>
                      <SaveBtn :disabled="!nameForQualification">
                        Сохранить
                      </SaveBtn>
                      <CancelBtn @click.stop.prevent="mainInfoEditable = false, nameForQualification = qualification.name">
                        Отменить
                      </CancelBtn>
                  </div>
                </FormInfoHeader>

                <div class="info__inner">
                  <div class="info__content">
                    <div class="info-row">

                      <div class="info-cell1" style="width: 30%; margin: 0 10px;">
                        <label for="qualification-code" class="label">Номер квалификации</label>

                        <div class="info-cell__field">
                          <div v-if="!mainInfoEditable" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                            {{qualification.code}}
                          </div>
                          <masked-input v-if="mainInfoEditable"
                                        mask="11.11111.11"
                                        id="qualification-code"
                                        name="code"
                                        placeholder="Не заполнено"
                                        class="input"
                                        :value="qualification.code"
                                        :disabled="!mainInfoEditable"/>
                        </div>
                      </div>

                      <div class="info-cell1" style="width: 30%; margin: 0 10px;">
                        <label for="qualification-level" class="label">Уровень квалификации</label>

                        <div class="info-cell__field">
                          <div v-if="!mainInfoEditable" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                            <div v-if="levelForQualification" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              {{levelForQualification}} уровень
                            </div>
                            <div v-else style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              Не указан
                            </div>
                          </div>
                          <v-select v-if="mainInfoEditable" class="select" placeholder="Уровень квалификации" label="name" v-model="levelForQualification" :options="[1,2,3,4,5,6,7,8,9]" :disabled="!mainInfoEditable"/>
                        </div>
                      </div>

                      <div class="info-cell1" style="width: 30%; margin: 0 10px;">
                        <label for="qualification-level" class="label">Подуровень квалификации</label>

                        <div class="info-cell__field">

                          <div v-if="!mainInfoEditable" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                            <div v-if="sublevelForQualification" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              {{sublevelForQualification}} подуровень
                            </div>
                            <div v-else style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              –
                            </div>
                          </div>

                          <v-select v-if="mainInfoEditable" class="select" placeholder="Не указан" v-model="sublevelForQualification" :options="[1,2,3,4,5,6,7,8,9]" />
                        </div>
                      </div>


                    </div>

                    <ul class="info-list">
                      <li class="info-list__item">
                        <span class="label info-list__label">Название проекта квалификации*</span>

                        <div class="info-list__field">
                          <textarea id="qualification-name" name="name" class="info-list__textarea"
                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !nameForQualification }"
                                    placeholder="Не заполнено" v-autogrow v-model="nameForQualification"
                                    :disabled="!mainInfoEditable"
                                    @input="nameForQualificationChanged = true"></textarea>
                        </div>
                      </li>
                      <li class="info-list__item">
                        <span class="label info-list__label">Область профессиональной деятельности</span>
                        <div class="info-list__field" v-if="GET_KIND_BY_ID(qualification.kind_id) && GET_AREA_BY_ID(GET_KIND_BY_ID(qualification.kind_id).area_id).name">
                           <span class="info-list__textarea">{{GET_AREA_BY_ID(GET_KIND_BY_ID(qualification.kind_id).area_id).name}}</span>
                        </div>
                        <div class="info-list__field mt-24" v-else-if="qualification.area_name">
                          <span class="info-list__textarea">{{ qualification.area_name }}</span>
                        </div>
                        <div class="info-list__field mt-24" v-else>
                          <span class="info-list__textarea">ОПД отсутствует</span>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Вид профессиональной деятельности (при наличии профессионального стандарта)</span>
                        <div class="info-list__field" v-if="GET_KIND_BY_ID(qualification.kind_id)">
                          <span class="info-list__input" v-html="GET_KIND_BY_ID(qualification.kind_id).name"></span>
                        </div>
                        <div class="info-list__field mt-24" v-else>
                          <span class="info-list__textarea">ВПД отсутствует</span>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Наименование профессионального стандарта (при наличии профессионального стандарта)</span>

                        <local-preloader v-if="standartLoader"/>

                        <div v-else class="info-list__field">
                          <span class="info-list__input" v-if="standardObj(qualification.standard_id)"
                                v-html="standardObj(qualification.standard_id).name"></span>
                          <div class="info-list__field mt-24" v-else>
                            <span class="info-list__textarea">Наименование ПС отсутствует</span>
                          </div>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Реквизиты профессионального стандарта (при наличии профессионального стандарта)</span>
                        <div class="info-list__field" v-if="qualification.standard_requisites">
                          <span class="info-list__input">
                            {{qualification.standard_requisites}}
                          </span>
                        </div>
                        <div class="info-list__field mt-24" v-else>
                          <span class="info-list__textarea">–</span>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Квалификационное требование:</span>
                        <div class="info-list__field">
                          <textarea id="qualification-requirement" name="requirement" class="info-list__textarea"
                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !requirementForQualification }"
                                    placeholder="Не заполнено" v-autogrow v-model="requirementForQualification"
                                    :disabled="!mainInfoEditable"></textarea>
                        </div>
                      </li>


                      <li class="info-list__item">
                        <span class="label info-list__label">Квалификационная характеристика, связанная с видом профессиональной деятельности:</span>
                        <div class="info-list__field">
                          <textarea id="qualification-characteristic" name="characteristic" class="info-list__textarea"
                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !requirementForQualification }"
                                    placeholder="Не заполнено"
                                    v-autogrow
                                    v-model="qualification.qualification_characteristic"
                                    :disabled="!mainInfoEditable"></textarea>
                        </div>
                      </li>


                      <li class="info-list__item">
                        <span
                            class="label info-list__label">Реквизиты протокола Совета об одобрении квалификации:</span>

                        <el-row :gutter="12">
                          <el-col :span="8">
                            <input v-model="protocol_details.date" :disabled="!mainInfoEditable" type="date"
                                   class="input html-datepicker">
                          </el-col>

                          <el-col :span="16">
                            <validate-input v-model="protocol_details.name" placeholder="Код"
                                            :disabled="!mainInfoEditable"/>
                          </el-col>

                        </el-row>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Реквизиты приказа Национального агентства об утверждении квалификации:</span>

                        <el-row :gutter="12">
                          <el-col :span="8">
                            <input v-model="order_details.date" type="date" class="input html-datepicker"
                                   :disabled="!mainInfoEditable">
                          </el-col>

                          <el-col :span="16">
                            <validate-input v-model="order_details.name" placeholder="Код"
                                            :disabled="!mainInfoEditable"/>
                          </el-col>

                        </el-row>
                      </li>

<!--                      <li class="info-list__item">-->
<!--                        <span class="label info-list__label">Дополнительные сведения:</span>-->

<!--                        <transition-group name="fade">-->
<!--                          <div class="info-list__field" v-for="(item,index) in extraForQualification" :key="index">-->
<!--                          <textarea class="info-list__textarea mb-8"-->
<!--                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !item }"-->
<!--                                    placeholder="Не заполнено" v-autogrow v-model="extraForQualification[index]"-->
<!--                                    :disabled="!mainInfoEditable"></textarea>-->
<!--                          </div>-->
<!--                        </transition-group>-->

<!--                        <transition name="fade">-->
<!--                          <div class="mt-8">-->
<!--                            <el-button-->
<!--                                v-if="mainInfoEditable"-->
<!--                                plain-->
<!--                                size="mini"-->
<!--                                icon="el-icon-plus"-->
<!--                                @click.stop="extraForQualification.push('')"-->
<!--                            > Добавить формальное образование и обучение-->
<!--                            </el-button>-->
<!--                          </div>-->
<!--                        </transition>-->
<!--                      </li>-->
<!--                      <li class="info-list__item">-->
<!--                        <span class="label info-list__label">Дополнительные характеристики:</span>-->

<!--                        <transition-group name="fade">-->
<!--                          <div class="info-list__field mb-8" v-for="(item,index) in addCharsForQualification"-->
<!--                               :key="index">-->
<!--                          <textarea class="info-list__textarea"-->
<!--                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !item }"-->
<!--                                    placeholder="Не заполнено" v-autogrow v-model="addCharsForQualification[index]"-->
<!--                                    :disabled="!mainInfoEditable"></textarea>-->
<!--                          </div>-->
<!--                        </transition-group>-->


<!--                        <div class="mt-8">-->
<!--                          <el-button-->
<!--                              v-if="mainInfoEditable"-->
<!--                              plain-->
<!--                              size="mini"-->
<!--                              icon="el-icon-plus"-->
<!--                              @click.stop="addCharsForQualification.push('')"-->
<!--                          > Добавить характеристику-->
<!--                          </el-button>-->
<!--                        </div>-->


<!--                        <button type="button" v-if="mainInfoEditable" class="btn btn_action-second mb-24"-->
<!--                                @click.stop="addCharsForQualification.push('')">-->
<!--                          Добавить характеристику-->
<!--                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"-->
<!--                               fill="currentColor" class="btn__icon">-->
<!--                            <path-->
<!--                                d="M11.25 5.25H6.75V0.75C6.75 0.551088 6.67098 0.360322 6.53033 0.21967C6.38968 0.0790178 6.19891 0 6 0C5.80109 0 5.61032 0.0790178 5.46967 0.21967C5.32902 0.360322 5.25 0.551088 5.25 0.75V5.25H0.75C0.551088 5.25 0.360322 5.32902 0.21967 5.46967C0.0790178 5.61032 0 5.80109 0 6C0 6.19891 0.0790178 6.38968 0.21967 6.53033C0.360322 6.67098 0.551088 6.75 0.75 6.75H5.25V11.25C5.25 11.4489 5.32902 11.6397 5.46967 11.7803C5.61032 11.921 5.80109 12 6 12C6.19891 12 6.38968 11.921 6.53033 11.7803C6.67098 11.6397 6.75 11.4489 6.75 11.25V6.75H11.25C11.4489 6.75 11.6397 6.67098 11.7803 6.53033C11.921 6.38968 12 6.19891 12 6C12 5.80109 11.921 5.61032 11.7803 5.46967C11.6397 5.32902 11.4489 5.25 11.25 5.25Z"></path>-->
<!--                          </svg>-->
<!--                        </button>-->
<!--                      </li>-->


                      <li class="data-list__item">
                        <section class="info">
                          <header class="info__head">
                            <div class="info__head-inner">
                              <div class="info__head-item">
                                <p class="info__title">Описание трудовых функций</p>
                              </div>
                              <div class="info__head-item">
                                <button v-if="!read && !workFunctionsByQualificationLoader" type="button"
                                        class="change-btn" @click.stop.prevent="elPanels.qualification = 2">
                                  Редактировать
                                  <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                                    <icon-edit/>
                                  </icon-base>
                                </button>
                                <button class="change-btn" v-if="read" type="button"
                                        @click.stop.prevent="elPanels.qualification = 2">
                                  Посмотреть
                                </button>
                              </div>
                            </div>
                          </header>

                          <local-preloader class="mt-24" v-if="workFunctionsByQualificationLoader"/>

                          <template v-else>
                      <li v-if="!workFunctionsByQualification.length">
                        <div class="info-list__field mt-24">
                          <p class="info-list__textarea">Трудовые функции отсутствуют</p>
                        </div>
                      </li>

                      <div class="info__inner" v-if="workFunctionsByQualification.length">
                        <div class="info__content">
                          <accordion class="accordion accordion_second">
                            <template #accordion-captions>
                              <div class="accordion__captions">
                                <div class="accordion-data-list">
                                  <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                      <span class="label">Код</span>
                                    </div>
                                    <div class="accordion-data-list__column">
                                      <span class="label">Наименование</span>
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                      <span class="label">Уровень</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <accordion-item v-for="(workFunction, index) in workFunctionsByQualification" :key="index">
                              <template #accordion-head>
                                <div class="accordion__trigger">
                                  <div class="accordion-data-list">
                                    <div class="accordion-data-list__item">
                                      <div class="accordion-data-list__column text-center"
                                           v-html="workFunction.code"></div>
                                      <div class="accordion-data-list__column" v-html="workFunction.name"></div>
                                      <div class="accordion-data-list__column text-center"
                                           v-html="workFunction.level"></div>
                                    </div>
                                  </div>

                                  <button type="button" class="accordion__toggler">
                                    <icon-base viewBox="0 0 14 8">
                                      <icon-arrow-down/>
                                    </icon-base>
                                  </button>
                                </div>
                              </template>

                              <div class="accordion__data">
                                <div class="accordion-data-list">
                                  <div class="accordion-data-list__item accordion-data-list__item--clickable"
                                       v-for="(child, index) in workFunction.work_functions" :key="index"
                                       @click="openWorkFunctionFromPanel(child)">
                                    <div class="accordion-data-list__column text-center"
                                         v-html="`${ child.subcode }`"></div>
                                    <div class="accordion-data-list__column" v-html="child.name"></div>
                                    <div class="accordion-data-list__column text-center" v-html="child.level"></div>
                                  </div>
                                </div>
                              </div>
                            </accordion-item>
                          </accordion>
                        </div>
                      </div>
</template>
</section>
</li>


<li class="data-list__item">
<section class="info">

  <FormInfoHeader heading="Связанные с ПК наименования должностей">
    <div v-if="!editableForms.related_jobs">
      <EditBtn v-if="!read" @click.prevent="editableForms.related_jobs = true">
        Редактировать
      </EditBtn>
    </div>
    <div v-else>
      <CancelBtn @click.stop.prevent="editableForms.related_jobs = false">
        Отменить
      </CancelBtn>
      <SaveBtn type="submit">
        Сохранить
      </SaveBtn>
    </div>

  </FormInfoHeader>

<!--  <header class="info__head">-->
<!--    <div class="info__head-inner">-->
<!--      <div class="info__head-item">-->
<!--        <p class="info__title"></p>-->
<!--      </div>-->
<!--      <div class="info__head-item">-->
<!--        <button v-if="!read" type="button" @click.prevent="elDialogs.relatedJobs = true" class="change-btn">-->
<!--          Редактировать-->
<!--          <icon-base viewBox="0 0 18 18" class="change-btn__icon">-->
<!--            <icon-edit/>-->
<!--          </icon-base>-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </header>-->
  <div class="info__inner">
    <div class="info__content">

      <RepeatableTextField v-model:value="relatedJobs"
                           :is-active="editableForms.related_jobs"
                           add-button-text="Добавить должность" />

      <div class="info-list__field" v-if="!relatedJobs.length">
        <p class="info-list__textarea" style="height: 60px">Связанные с ПК должности отсутствуют</p>
      </div>
<!--      <div class="related-job__item" v-if="relatedJobs.length" v-for="(job, index) in relatedJobs" :key="index">-->
<!--        <el-row :gutter="12">-->
<!--          <el-col :span="18">-->
<!--            <span style="font-size: 18px; font-weight: 500;">-->
<!--              {{ job.name }}-->
<!--            </span>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            {{ job.code }}-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="12" style="margin-top: 20px;">-->
<!--          <el-col :span="6">-->
<!--            {{ job.document }}-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            {{ job.document_name }}-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            {{ job.requisites }}-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </div>-->



    </div>
  </div>
</section>
</li>

<li class="data-list__item">

<FormInfoHeader heading="Список цифровых документов">
  <div>
    <EditBtn v-if="!read" @click.prevent="elDialogs.relatedJobs = true">
      Редактировать
    </EditBtn>
  </div>

</FormInfoHeader>
<div class="info__inner">
  <div class="info__content">
    <div v-if="this.qualification.competences.length > 0" style="max-height: 300px; overflow-y: scroll;">
      <div class="related-job__item" v-for="(competence, index) in this.qualification.competences" :key="index">
        <el-row :gutter="12">
          <el-col :span="18">
                <span style="font-size: 18px; font-weight: 500;">
                  {{ competence.resource }}
                </span>
          </el-col>
          <el-col :span="6">
            {{ competence.doc_code }}
          </el-col>
        </el-row>
        <el-row :gutter="12" style="margin-top: 20px;">
          <el-col :span="24">
            {{ competence.doc_name }}
          </el-col>
        </el-row>
      </div>
    </div>


  </div>
</div>



</li>



<form @submit.prevent="updateQualification($event, 'mainInfoEditable')" style="margin-top: 6rem;">
<header class="info__head">
  <div class="info__head-inner">
    <div class="info__head-item">
      <p class="info__title">
        Основные пути получения квалификации
      </p>
    </div>
    <div class="info__head-item" v-if="!editableForms.ways_to_get_qualification">
      <button v-if="!read" type="button" class="change-btn"
              @click.prevent="editableForms.ways_to_get_qualification = true">
        Редактировать

        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
          <icon-edit/>
        </icon-base>
      </button>
    </div>
    <div class="info__head-item" v-else>
      <button type="submit" class="btn btn_success btn_small">
        Сохранить

        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
          <icon-save/>
        </icon-base>
      </button>

      <button type="button" class="btn btn_danger btn_small"
              @click.stop.prevent="editableForms.ways_to_get_qualification = false, nameForQualification = qualification.name">
        Отменить
        <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
          <icon-cancel/>
        </icon-base>
      </button>
    </div>
  </div>
</header>
<div class="info__inner">
  <div class="info__content">
    <ul class="info-list">
      <li class="info-list__item" style="margin-bottom: 25px;">

        <div class="info-list__field">

<!--          <RepeatableTextField-->
<!--              label="Неформальное образование и самообучение:"-->
<!--              :is-active="editableForms.ways_to_get_qualification"-->
<!--              add-button-text="Добавить неформальное образование"-->
<!--              v-model:value="waysToGetQualification.self_education"/>-->


          <div>
            <span class="label info-list__label">Формальное образование и обучение:</span>
            <transition-group name="fade">
              <div class="mb-4"
                  v-for="(formal_education, index) in waysToGetQualification.formal_education" :key="index">
                  <textarea class="info-list__textarea"
                  :class="{ 'is-active': editableForms.ways_to_get_qualification}"
                  placeholder="Не заполнено" v-autogrow
                  v-model="waysToGetQualification.formal_education[index]"
                  :disabled="!editableForms.ways_to_get_qualification"></textarea>
              </div>
            </transition-group>

            <transition name="fade">
              <el-button
                  v-if="editableForms.ways_to_get_qualification"
                  plain
                  size="mini"
                  icon="el-icon-plus"
                  @click.prevent="addFormalEducationItem"
              > Добавить формальное образование и обучение
              </el-button>
            </transition>
          </div>



          <div class="mt-16">
            <span class="label info-list__label">Неформальное образование и самообучение:</span>
            <transition-group name="fade">
              <div class="mb-4"
                  v-for="(self_education, index) in waysToGetQualification.self_education" :key="index">
                <textarea class="info-list__textarea"
                          :class="{ 'is-active': editableForms.ways_to_get_qualification}"
                          placeholder="Не заполнено" v-autogrow
                          v-model="waysToGetQualification.self_education[index]"
                          :disabled="!editableForms.ways_to_get_qualification"></textarea>
              </div>
            </transition-group>

            <transition name="fade">
              <el-button
                  v-if="editableForms.ways_to_get_qualification"
                  plain
                  size="mini"
                  icon="el-icon-plus"
                  @click.prevent="addSelfEducationItem"
              > Добавить неформальное образование
              </el-button>
            </transition>

          </div>

          <div class="mt-16">
            <span class="label info-list__label">Опыт практической работы:</span>
            <transition-group name="fade">
              <div class="mb-4"
                  v-for="(work_experience, index) in waysToGetQualification.work_experience" :key="index">
                <textarea class="info-list__textarea"
                          :class="{ 'is-active': editableForms.ways_to_get_qualification}"
                          placeholder="Не заполнено" v-autogrow
                          v-model="waysToGetQualification.work_experience[index]"
                          :disabled="!editableForms.ways_to_get_qualification"></textarea>
              </div>
            </transition-group>


            <transition name="fade">
              <el-button
                  v-if="editableForms.ways_to_get_qualification"
                  plain
                  size="mini"
                  icon="el-icon-plus"
                  @click.prevent="addWorkExperienceItem"
              > Добавить опыт практической работы
              </el-button>
            </transition>
          </div>

        </div>


      </li>
    </ul>
  </div>
</div>
</form>


<form @submit.prevent="updateQualification($event, 'mainInfoEditable')">

<FormInfoHeader heading="Специальные условия для допуска к работе">
  <div v-if="!read">
    <EditBtn v-if="!editableForms.special_conditions"
             @click.prevent="editableForms.special_conditions = true">
      Редактировать
    </EditBtn>

    <div v-else>
      <SaveBtn>Сохранить</SaveBtn>
      <CancelBtn @click.stop.prevent="editableForms.special_conditions = false;">
        Отменить
      </CancelBtn>
    </div>
  </div>

</FormInfoHeader>
<!--<header class="info__head">-->
<!--  <div class="info__head-inner">-->
<!--    <div class="info__head-item">-->
<!--      <p class="info__title">Специальные условия допуска к работе</p>-->
<!--    </div>-->
<!--    <div class="info__head-item" v-if="!editableForms.special_conditions">-->
<!--      <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.special_conditions = true">-->
<!--        Редактировать-->

<!--        <icon-base viewBox="0 0 18 18" class="change-btn__icon">-->
<!--          <icon-edit/>-->
<!--        </icon-base>-->
<!--      </button>-->
<!--    </div>-->
<!--    <div class="info__head-item" v-else>-->
<!--      <button type="submit" class="btn btn_success btn_small">-->
<!--        Сохранить-->

<!--        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">-->
<!--          <icon-save/>-->
<!--        </icon-base>-->
<!--      </button>-->

<!--      <button type="button" class="btn btn_danger btn_small"-->
<!--              @click.stop.prevent="editableForms.special_conditions = false, nameForQualification = qualification.name">-->
<!--        Отменить-->
<!--        <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">-->
<!--          <icon-cancel/>-->
<!--        </icon-base>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</header>-->
<div class="info__inner">
  <div class="info__content">
    <ul class="info-list">
      <li class="info-list__item" style="margin-bottom: 25px;">
<!--        <span class="label info-list__label">Особые условия для допуска к работе:</span>-->

        <RepeatableTextField v-model:value="extraForQualification"
                             label="Особые условия для допуска к работе:"
                             add-button-text="Добавить условие допуска к работе"
                             :is-active="editableForms.special_conditions"
        />

      </li>
    </ul>
  </div>
</div>
</form>


<form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
<header class="info__head">
  <div class="info__head-inner">
    <div class="info__head-item">
      <p class="info__title">
        Наличие специального права на работу
      </p>
    </div>
    <div class="info__head-item" v-if="!editableForms.rights_to_work">
      <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.rights_to_work = true">
        Редактировать
        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
          <icon-edit/>
        </icon-base>
      </button>
    </div>
    <div class="info__head-item" v-else>
      <button type="submit" class="btn btn_success btn_small">
        Сохранить
        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
          <icon-save/>
        </icon-base>
      </button>

      <button type="button" class="btn btn_danger btn_small"
              @click.stop.prevent="editableForms.rights_to_work = false, nameForQualification = qualification.name">
        Отменить
        <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
          <icon-cancel/>
        </icon-base>
      </button>
    </div>
  </div>
</header>
<div class="info__inner">
  <div class="info__content">
    <ul class="info-list">
      <li class="info-list__item" style="margin-bottom: 25px;">
        <span class="label info-list__label">Наличие специального права на работу:</span>


        <div class="info-list__field">
          <div>
            <transition-group name="fade">
            <div
                v-for="(special_condition, index) in rights_to_work" :key="index">
                <textarea class="info-list__textarea"
                    style="margin-bottom: 8px;"
                    :class="{ 'is-active': editableForms.rights_to_work}"
                    placeholder="Наличие специального права в соответствии с ФЗ и иными нормативными актами"
                    v-autogrow
                    v-model="rights_to_work[index]"
                    :disabled="!editableForms.rights_to_work"></textarea>
            </div>
            </transition-group>

            <transition name="fade">

              <el-button
                  v-if="editableForms.rights_to_work"
                  plain
                  size="mini"
                  icon="el-icon-plus"
                  @click.prevent="rights_to_work.push('')"
              > Добавить специальное право на работу
              </el-button>

            </transition>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
</form>


<form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
<header class="info__head">
  <div class="info__head-inner">
    <div class="info__head-item">
      <p class="info__title">
        Перечень документов для прохождения проф. экзамена
      </p>
    </div>
    <div class="info__head-item" v-if="!editableForms.docs">
      <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.docs = true">
        Редактировать
        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
          <icon-edit/>
        </icon-base>
      </button>
    </div>
    <div class="info__head-item" v-else>
      <button type="submit" class="btn btn_success btn_small">
        Сохранить
        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
          <icon-save/>
        </icon-base>
      </button>

      <button type="button" class="btn btn_danger btn_small"
              @click.stop.prevent="editableForms.docs = false, nameForQualification = qualification.name">
        Отменить
        <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
          <icon-cancel/>
        </icon-base>
      </button>
    </div>
  </div>
</header>
<div class="info__inner">
  <div class="info__content">
    <ul class="info-list">
      <li class="info-list__item">
        <span class="label info-list__label">Документы для прохождения профессионального экзамена:</span>
        <transition-group name="fade">
          <div v-for="(documentSet, index) in docsForQualification" :key="index"
               style="">
            <transition-group name="fade">
              <div v-for="(document, docIndex) in documentSet" :key="docIndex">
                                                    <textarea class="info-list__textarea"
                                                              style="margin-bottom: 5px;"
                                                              :class="{ 'is-active': editableForms.docs, 'info-list__textarea_error': false }"
                                                              placeholder="Не заполнено"
                                                              v-model="docsForQualification[index][docIndex]"
                                                              v-autogrow
                                                              :disabled="!editableForms.docs">{{ document }}</textarea>

              </div>
            </transition-group>

            <el-button
                v-if="editableForms.docs"
                plain
                size="mini"
                icon="el-icon-plus"
                @click.prevent="docsForQualification[index].push('')"
            > Добавить документ
            </el-button>

            <div v-if="index !== docsForQualification.length - 1" style="width: 100%; display: flex; align-items: center; margin-bottom: 28px;">
              <div style="width:100%; height: 2px; background: #e2e2e2;"></div>
              <span style="margin: 0 15px; font-weight: 500; color: #535658;">ИЛИ</span>
              <div style="width:100%;height: 2px; background: #e2e2e2;"></div>
            </div>
          </div>
        </transition-group>


        <div class="mb-24">
          <transition name="fade">
            <el-button
                v-if="editableForms.docs"
                plain
                type="primary"
                size="medium"
                icon="el-icon-document-add"
                @click.prevent="docsForQualification.push([''])"
            > Добавить альтернативный список документов
            </el-button>
          </transition>
        </div>

      </li>
    </ul>
  </div>
</div>
</form>


<form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
<header class="info__head">
  <div class="info__head-inner">
    <div class="info__head-item">
      <p class="info__title">
        Срок действия свидетельства о квалификации
      </p>
    </div>
    <div class="info__head-item" v-if="!editableForms.validity">
      <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.validity = true">
        Редактировать

        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
          <icon-edit/>
        </icon-base>
      </button>
    </div>
    <div class="info__head-item" v-else>
      <button type="submit" class="btn btn_success btn_small">
        Сохранить
        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
          <icon-save/>
        </icon-base>
      </button>

      <button type="button" class="btn btn_danger btn_small"
              @click.stop.prevent="editableForms.validity = false, nameForQualification = qualification.name">
        Отменить
        <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
          <icon-cancel/>
        </icon-base>
      </button>
    </div>
  </div>
</header>
<div class="info__inner">
  <div class="info__content">
    <ul class="info-list">
      <li class="info-list__item" style="margin-bottom: 25px;">

        <CellInput
            label="Срок действия свидетельства"
            id="qualification-validity"
            name="validity"
            placeholder="Не заполнено"
            v-model="validityForQualification"
            :disabled="!editableForms.validity"
        />

        <CellInput
            label="Квалификация утрачивает силу"
            id="qualification-invalid-at"
            name="invalid_at"
            placeholder="Не заполнено"
            v-model="invalid_at"
            :disabled="!editableForms.validity"
        />

      </li>
    </ul>
  </div>
</div>
</form>


</ul>
</div>
</div>
</form>

</section>
</li>
<li class="data-list__item">
<section class="info">
  <header class="info__head">
    <div class="info__head-inner">
      <div class="info__head-item">
        <p class="info__title">Образовательные программы</p>
      </div>
      <div class="info__head-item">
        <button v-if="!read && !programsByQualificationLoader" type="button" class="change-btn"
                @click.prevent="elDialogs.programs = true">
          Редактировать
          <icon-base viewBox="0 0 18 18" class="change-btn__icon">
            <icon-edit/>
          </icon-base>
        </button>
        <button v-if="read && programsByQualification.length" class="change-btn" type="button"
                @click.prevent="elDialogs.programs = true">
          Посмотреть
        </button>
      </div>
    </div>
  </header>
</section>

<local-preloader class="mt-24" v-if="programsByQualificationLoader"/>

<template v-else>
<li v-if="!programsByQualification.length">
<div class="info-li st__field mt-24 mb-24">
  <p class="info-list__textarea" style="height: 60px;">Образовательные программы отсутствуют</p>
</div>
</li>

<div class="info__inner" v-else>
<div class="info__content">
  <div class="programs-list">
    <div class="programs-list__inner">
      <div class="programs-list__item" v-for="item in programsByQualification" :key="item.id">
        <div class="programs-list__content">
          <div class="programs-list__content-item" v-html="item.name"></div>
        </div>

        <footer class="programs-list__footer">
          Повышение квалификации

          <!--                                                    <icon-base viewBox="0 0 8 14" class="programs-list__more">-->
          <!--                                                        <icon-arrow-right />-->
          <!--                                                    </icon-base>-->
        </footer>
      </div>
    </div>
  </div>
</div>
</div>
</template>
</li>
</ul>
</div>
</div>
<div class="wizard-panel__inner" v-else-if="panels.qualification === 2">
<div class="wizard-panel__column js-wizard-panel-column pb-0">
  <div class="badge wizard-panel__badge" v-html="qualification.name"></div>

  <h2>Трудовые функции</h2>

  <button type="button" class="btn btn_action-second btn_transparent" v-if="!read"
          @click="elDialogs.workFunctions = true">
    Создать или найти трудовую функцию
    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
      <icon-action/>
    </icon-base>
  </button>

  <accordion class="accordion accordion_second">
    <template slot="accordion-captions">
      <div class="accordion__captions">
        <div class="accordion-data-list">
          <div class="accordion-data-list__item">
            <div class="accordion-data-list__column text-center">
              <span class="label">Код</span>
            </div>
            <div class="accordion-data-list__column">
              <span class="label">Наименование</span>
            </div>
            <div class="accordion-data-list__column text-center">
              <span class="label">Уровень</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <accordion-item v-for="(workFunction, index) in workFunctionsByQualification" :active="index === 0"
                    :key="workFunction.id">
      <template slot="accordion-head">
        <div class="accordion__trigger">
          <div class="accordion-data-list">
            <div class="accordion-data-list__item">
              <div class="accordion-data-list__column text-center" v-html="workFunction.code"></div>
              <div class="accordion-data-list__column" v-html="workFunction.name"></div>
              <div class="accordion-data-list__column text-center" v-html="workFunction.level"></div>
            </div>
          </div>

          <button type="button" class="accordion__toggler">
            <icon-base viewBox="0 0 14 8">
              <icon-arrow-down/>
            </icon-base>
          </button>
        </div>
      </template>

      <div class="accordion__data" v-if="workFunction.work_functions.length">
        <div class="accordion-data-list accordion-data-list_editable">
          <div
              :class="{ 'accordion-data-list__item': true, 'is-active': item === activeWorkFunction || (!activeWorkFunction && index === 0 && count === 0 && getWorkFunctionItems(item)) }"
              v-for="(item, count) in workFunction.work_functions" @click="getWorkFunctionItems(item)">
            <div class="accordion-data-list__column text-center" v-html="`${ item.subcode }`">
            </div>
            <div class="accordion-data-list__column" v-html="item.name">
            </div>
            <div class="accordion-data-list__column text-center">
              {{ item.level }}

              <selector-btn class="ml-auto" v-if="!read" :options="accordionWorkFunctionOptionsForBtn"
                            portal="selectorModal" :toRight="true" :clickStop="true"
                            :params="{ commonWorkFunctionsId: workFunction.id, commonWorkFunctionsLevel: workFunction.level, id: item.id, workFunction: item }"
                            @clickOnItem="callback"></selector-btn>
            </div>
          </div>
        </div>
      </div>
    </accordion-item>
  </accordion>
</div>
<div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
  <div v-if="activeWorkFunction">
    <header class="panel-head">
      <div class="panel-head__inner">
        <div class="panel-head__item">
          <h2 v-html="activeWorkFunction.name"></h2>

          <p class="panel-head__text">Компетенции были добавлены автоматически, на&nbsp;основе выбранной квалификации.
            <br/> Вы&nbsp;можете добавлять, создавать и&nbsp;удалять компетенции.</p>
        </div>
      </div>
    </header>

    <Tabs :key="activeWorkFunction.id">

      <Tab title="Трудовые действия">
        <button type="button" v-if="!read" class="btn btn_action-second btn_full mb-24"
                @click.prevent="elDialogs.workActions = true">
          Добавить трудовые действия
          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
            <icon-action/>
          </icon-base>
        </button>

        <ul class="actions-list">
          <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.actions.length === 0">
            Нет трудовых действий для отображения
          </li>
          <li class="actions-list__item" v-for="action in workFunctionItems.actions">
            <div class="action">
              <span v-html="action.name"></span>

              <selector-btn v-if="!read" class="ml-16" :options="accordionActionOptionsForBtn"
                            :params="{ id: action.id, item: action }" @clickOnItem="callback"></selector-btn>
            </div>
          </li>
        </ul>
      </Tab>

      <Tab title="Знания">
        <button type="button" class="btn btn_action-second btn_full mb-24" v-if="!read"
                @click.prevent="elDialogs.workKnowledge = true">
          Добавить знания

          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
            <icon-action/>
          </icon-base>
        </button>

        <ul class="actions-list">
          <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.knowledge.length === 0">
            Нет знаний для отображения
          </li>
          <li class="actions-list__item" v-for="knowledge in workFunctionItems.knowledge">
            <div class="action">
              <span v-html="knowledge.name"></span>

              <selector-btn v-if="!read" class="ml-16" :options="accordionWorkKnowledgeOptionsForBtn"
                            :params="{ id: knowledge.id, item: knowledge }" @clickOnItem="callback"></selector-btn>
            </div>
          </li>
        </ul>
      </Tab>

      <Tab title="Умения">
        <button type="button" class="btn btn_action-second btn_full mb-24" v-if="!read"
                @click.prevent="elDialogs.workSkills = true">
          Добавить умения
          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
            <icon-action/>
          </icon-base>
        </button>

        <ul class="actions-list">
          <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.skills.length === 0">
            Нет умений для отображения
          </li>
          <li class="actions-list__item" v-for="skill in workFunctionItems.skills">
            <div class="action">
              <span v-html="skill.name"></span>

              <selector-btn v-if="!read" class="ml-16" :options="accordionWorkSkillOptionsForBtn"
                            :params="{ id: skill.id, item: skill }" @clickOnItem="callback"></selector-btn>
            </div>
          </li>
        </ul>
      </Tab>


      <Tab title="Другие характеристики">

        <ul class="actions-list">
          <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.additionals.length === 0">
            Нет трудовых действий для отображения
          </li>
          <li class="actions-list__item" v-for="additional in workFunctionItems.additionals">
            <div class="action">
              <span v-html="additional.name"></span>

              <!--              <selector-btn v-if="!read" class="ml-16" :options="accordionActionOptionsForBtn" :params="{ id: action.id, item: action }"  @clickOnItem="callback"></selector-btn>-->
            </div>
          </li>
        </ul>

      </Tab>

    </Tabs>
  </div>
</div>
</div>

<!-- DIALOGS -->
<related-job-dialog v-if="elDialogs.relatedJobs"/>
<programs-dialog v-if="qualification.id" :qualificationId="qualification.id" :read="read"/>
<work-actions-dialog :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
<work-functions-dialog v-if="qualification.id" :qualificationId="qualification.id"/>
<work-knowledge-dialog :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
<work-skills-dialog :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
<work-function-rename :activeWorkFunction="activeWorkFunctionForRename"/>
<work-functions-item-rename :activeWorkFunctionItem="activeWorkFunctionItem" @updateItems="updateWorkFunctionItems"/>
<!-- /DIALOGS -->
</wizard-panel>
</template>

<script>
import Vue from 'vue';
import MaskedInput from 'vue-masked-input';
import ValidateInput from '@/components/ValidateInput'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

import panel from '@/mixins/panel';
import constants from '@/constants.js';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import ProgramsDialog from '@/components/Dialogs/ProgramsDialog';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import WizardPanel from '@/components/WizardPanels/WizardPanel';
import WorkActionsDialog from '@/components/Dialogs/WorkActionsDialog';
import WorkFunctionsDialog from '@/components/Dialogs/WorkFunctionsDialog';
import WorkKnowledgeDialog from '@/components/Dialogs/WorkKnowledgeDialog';
import WorkSkillsDialog from '@/components/Dialogs/WorkSkillsDialog';
import SelectorBtn from '@/components/SelectorBtn';
import LocalPreloader from '@/components/LocalPreloader'
import WorkFunctionRename from '@/components/Dialogs/WorkFunctionRename';
import WorkFunctionsItemRename from '@/components/Dialogs/WorkFunctionsItemRename';
import RelatedJobDialog from "@/components/Dialogs/RelatedJobDialog";
import CellInput from "@/components/CellInput.vue";
import FormInfoHeader from "@/components/Panels/FormInfoHeader.vue";
import EditBtn from "@/components/Buttons/EditBtn.vue";
import SaveBtn from "@/components/Buttons/SaveBtn.vue";
import CancelBtn from "@/components/Buttons/CancelBtn.vue";
import RepeatableTextField from "@/components/Forms/RepeatableTextField.vue";

const initialData = () => {
  return {
    activeWorkFunction: null,
    activeWorkFunctionForRename: {},
    activeWorkFunctionItem: {},
    nameForQualification: '',
    levelForQualification: '',
    sublevelForQualification: '',
    validityForQualification: '',
    invalid_at: '',
    requirementForQualification: '',
    docsForQualification: [],
    extraForQualification: [],
    addCharsForQualification: [],
    waysToGetQualification: {
      formal_education: ['–'],
      work_experience: ['–'],
      self_education: ['–'],
    },
    relatedJobs: [],
    competences: [],
    special_conditions: [],
    protocol_details: {},
    order_details: {},
    rights_to_work: ['–'],

    editRelatedJobs: false,
    mainInfoEditable: false,
    workFunctionsDescription: false,
    nameForQualificationChanged: false,

    editableForms: {
      related_jobs: false,
      special_conditions: false,
      rights_to_work: false,
      ways_to_get_qualification: false,
      docs: false,
      validity: false,
    },

    accordionWorkFunctionOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkFunctionItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkFunctionItem'
      }
    ],
    accordionActionOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkActionItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkActionItem'
      }
    ],
    accordionWorkKnowledgeOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkKnowledgeItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkKnowledgeItem'
      }
    ],
    accordionWorkSkillOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkSkillItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkSkillItem'
      }
    ]
  }
}

export default {
  mixins: [panel],
  components: {
    RepeatableTextField,
    CancelBtn,
    SaveBtn,
    EditBtn,
    FormInfoHeader,
    CellInput,
    RelatedJobDialog,
    Accordion,
    AccordionItem,
    MaskedInput,
    ValidateInput,
    ProgramsDialog,
    Tab,
    Tabs,
    WizardPanel,
    WorkActionsDialog,
    WorkFunctionsDialog,
    WorkKnowledgeDialog,
    WorkSkillsDialog,
    SelectorBtn,
    LocalPreloader,
    WorkFunctionRename,
    WorkFunctionsItemRename
  },
  props: {
    read: {
      type: Boolean,
      default: false
    },
    workFunctionsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    programsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    standartLoader: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return initialData();
  },
  methods: {
    ...mapActions('editor', [
      'LOAD_WORK_FUNCTIONS_BY_QUALIFICATION',
      'LOAD_PROGRAMS_BY_QUALIFICATION',
      'LOAD_WORK_FUNCTION_ITEMS',
      'GET_WORK_ACTIONS_BY_QUALIFICATION',
      'GET_WORK_KNOWLEDGE_BY_QUALIFICATION',
      'GET_WORK_SKILLS_BY_QUALIFICATION',
      'GET_WORK_KNOWLEDGE_BY_QUALIFICATION',
      'CREATE_WORK_FUNCTION',
      'UPDATE_QUALIFICATION',
      'UPDATE_WORK_FUNCTIONS_BY_QUALIFICATION',
      'UPDATE_WORK_FUNCTION_ITEMS',
      'DELETE_WORK_FUNCTIONS_BY_QUALIFICATION'
    ]),
    ...mapMutations('editor', ['GROUP_QUALIFICATIONS', 'SET_QUALIFICATIONS']),

    closePanel() {
      Object.assign(this.$data, initialData());
    },
    callback(emitObj) {
      this[emitObj.callback](emitObj.args)
    },

    addSelfEducationItem() {
      if (this.waysToGetQualification.self_education && Array.isArray(this.waysToGetQualification.self_education)) {
        this.waysToGetQualification.self_education.push('');
      } else {
        this.waysToGetQualification.self_education = [''];
      }
      this.$forceUpdate();
    },

    addWorkExperienceItem() {
      if (this.waysToGetQualification.work_experience && Array.isArray(this.waysToGetQualification.work_experience)) {
        this.waysToGetQualification.work_experience.push('');
      } else {
        this.waysToGetQualification.work_experience = [''];
      }
      this.$forceUpdate();
    },

    addFormalEducationItem() {
      if (this.waysToGetQualification.formal_education && Array.isArray(this.waysToGetQualification.formal_education)) {
        this.waysToGetQualification.formal_education.push('');
      } else {
        this.waysToGetQualification.formal_education = [''];
      }
      this.$forceUpdate();
    },

    async getWorkFunctionItems(item) {
      await this.LOAD_WORK_FUNCTION_ITEMS(item.id)

      this.activeWorkFunction = item;
    },


    async openWorkFunctionFromPanel(item) {
      await this.getWorkFunctionItems(item);
      this.elPanels.qualification = 2;
    },

    openPanel() {
      console.log('panel opened')
      this.nameForQualification = this.qualification.name
    },

    async deleteWorkFunctionItem({commonWorkFunctionsId, id}) {
      const params = {
        qualificationId: this.qualification.id,
        ids: [id],
      }
      await this.DELETE_WORK_FUNCTIONS_BY_QUALIFICATION(params)

      await this.LOAD_WORK_FUNCTIONS_BY_QUALIFICATION(this.qualification.id)

      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))

      newWorkFunctionItems.workFunctionId = commonWorkFunctionsId
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      await this.UPDATE_WORK_FUNCTION_ITEMS(newWorkFunctionItems)
      await this.GET_WORK_ACTIONS_BY_QUALIFICATION(this.qualification.id)
      await this.GET_WORK_KNOWLEDGE_BY_QUALIFICATION(this.qualification.id)
      await this.GET_WORK_SKILLS_BY_QUALIFICATION(this.qualification.id)

      let workFunctionsLength = 0
      this.workFunctionsByQualification.forEach(element => {
        workFunctionsLength += element.work_functions.length
      });

      const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
      await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, {
        'work_functions': workFunctionsLength,
        'work_actions': this.workActions.length,
        'work_knowledge': this.workKnowledge.length,
        'work_skills': this.workSkills.length
      }) : qualification))
      this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
    },
    async deleteWorkActionItem({id}) {
      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.filter(el => el.id != id)

      newWorkFunctionItems.workFunctionId = this.activeWorkFunction.id
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      await this.UPDATE_WORK_FUNCTION_ITEMS(newWorkFunctionItems)

      await this.GET_WORK_ACTIONS_BY_QUALIFICATION(this.qualification.id)

      const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
      await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, {'work_actions': this.workActions.length}) : qualification))
      this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
    },
    async deleteWorkKnowledgeItem({id}) {
      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.filter(el => el.id != id)

      newWorkFunctionItems.workFunctionId = this.activeWorkFunction.id
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      await this.UPDATE_WORK_FUNCTION_ITEMS(newWorkFunctionItems)

      await this.GET_WORK_KNOWLEDGE_BY_QUALIFICATION(this.qualification.id)

      const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
      await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, {'work_knowledge': this.workKnowledge.length}) : qualification))
      this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
    },
    async deleteWorkSkillItem({id}) {
      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.filter(el => el.id != id)

      newWorkFunctionItems.workFunctionId = this.activeWorkFunction.id
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      await this.UPDATE_WORK_FUNCTION_ITEMS(newWorkFunctionItems)

      await this.GET_WORK_SKILLS_BY_QUALIFICATION(this.qualification.id)

      const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
      await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, {'work_skills': this.workSkills.length}) : qualification))
      this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
    },

    editWorkFunctionItem({workFunction, commonWorkFunctionsLevel, commonWorkFunctionsId}) {
      this.activeWorkFunctionForRename = Object.assign(workFunction, {
        common_function_id: commonWorkFunctionsId,
        level: commonWorkFunctionsLevel
      })
      this.elDialogs.workFunctionsRename = true
    },
    editWorkActionItem({item}) {
      this.activeWorkFunctionItem = JSON.parse(JSON.stringify(Object.assign(item, {
        work_function_id: this.activeWorkFunction.id,
        type: 'action'
      })))
      this.elDialogs.workFunctionsItemRename = true
    },
    editWorkKnowledgeItem({item}) {
      this.activeWorkFunctionItem = JSON.parse(JSON.stringify(Object.assign(item, {
        work_function_id: this.activeWorkFunction.id,
        type: 'knowledge'
      })))
      this.elDialogs.workFunctionsItemRename = true
    },
    editWorkSkillItem({item}) {
      this.activeWorkFunctionItem = JSON.parse(JSON.stringify(Object.assign(item, {
        work_function_id: this.activeWorkFunction.id,
        type: 'skill'
      })))
      this.elDialogs.workFunctionsItemRename = true
    },

    onlyNumber(e) {
      if ((e.keyCode < 49 || e.keyCode > 57)) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    updateWorkFunctionItems() {
      this.LOAD_WORK_FUNCTION_ITEMS(this.activeWorkFunction.id)
    },
    async updateQualification(e, editable) {
      // Собираем новые значения и отправляем
      const formData = new FormData(e.target);

      const params = {};

      for (const pair of formData.entries()) {
        params[pair[0]] = pair[1];
      }

      params['level'] = this.levelForQualification;
      params['sublevel'] = this.sublevelForQualification;
      params['docs'] = this.docsForQualification.filter(n => n);
      params['extra'] = this.extraForQualification.filter(n => n);
      params['add_chars'] = this.addCharsForQualification.filter(n => n);
      params['ways_to_get_qualification'] = this.waysToGetQualification;
      params['related_jobs'] = this.relatedJobs;
      params['special_conditions'] = this.special_conditions;
      params['rights_to_work'] = this.rights_to_work;
      params['competences'] = null;

      if (this.order_details.name && this.order_details.date) {
        params['order_details'] = this.order_details;
      }

      if (this.protocol_details.date && this.protocol_details.name) {
        params['protocol_details'] = this.protocol_details;
      }

      console.log(this.protocol_details);

      await this.UPDATE_QUALIFICATION({
        ...this.qualification,
        ...params
      });

      if (this.nameForQualificationChanged) {
        const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
        await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, {name: this.nameForQualification}) : qualification))
        await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
      }

      this[editable] = false;

      this.editableForms.special_conditions = false;
      this.editableForms.rights_to_work = false;
      this.editableForms.ways_to_get_qualification = false;
      this.editableForms.docs = false;
      this.editableForms.validity = false;

    },
    standardObj(standard_id) {
      if (standard_id === null) {
        return false;
      }
      return this.standard != null ? this.standard : this.GET_STANDARD_BY_ID(standard_id);
    },
    openJobsDialog() {

    }
  },
  computed: {
    ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_KIND_BY_ID', 'GET_STANDARD_BY_ID']),
    ...mapState('common', ['panels']),
    ...mapState('editor', ['standard', 'programsByQualification', 'groupItemsBy', 'qualification', 'qualifications', 'workFunctionsByQualification', 'workFunctionItems', 'workActions', 'workSkills', 'workKnowledge']),
  },
  watch: {
    'qualification.name': function (val) {
      this.nameForQualification = val
    },
    'qualification.level': function (val) {
      this.levelForQualification = val
    },
    'qualification.sublevel': function (val) {
      this.sublevelForQualification = val
    },
    'qualification.docs': function (val) {
      if (Array.isArray(val) && val.every(item => typeof item === 'string')) {
        this.docsForQualification = [val]
      } else {
        this.docsForQualification = val
      }
    },
    'qualification.extra': function (val) {
      this.extraForQualification = val
    },
    'qualification.add_chars': function (val) {
      this.addCharsForQualification = val
    },
    'qualification.requirement': function (val) {
      this.requirementForQualification = val
    },
    'qualification.invalid_at': function (val) {
      this.invalid_at = val;
    },
    'qualification.validity': function (val) {
      this.validityForQualification = val
    },
    'qualification.ways_to_get_qualification': function (val) {
      if (val.length === 0) {
        this.waysToGetQualification = {formal_education: [''], self_education: [''], work_experience: ['']};
      } else {
        this.waysToGetQualification = val
      }
    },
    'qualification.related_jobs': function (val) {
      this.relatedJobs = val;
    },
    'qualification.special_conditions': function (val) {
      this.special_conditions = val;
    },
    'qualification.order_details': function (val) {
      this.order_details = Object.assign({}, val);
    },
    'qualification.protocol_details': function (val) {
      console.log(val);
      this.protocol_details = Object.assign({}, val);
    },
    'qualification.rights_to_work': function (val) {
      this.rights_to_work = val;
    }
  },
  mounted() {
    this.nameForQualification = this.qualification.name
    this.levelForQualification = this.qualification.level
    this.sublevelForQualification = this.qualification.sublevel
    this.validityForQualification = this.qualification.validity
    this.invalid_at = this.qualification.invalid_at;
    this.requirementForQualification = this.qualification.requirement
    this.docsForQualification = this.qualification.docs
    this.extraForQualification = this.qualification.extra
    this.addCharsForQualification = this.qualification.add_chars
    this.relatedJobs = this.qualification.related_jobs;
    this.special_conditions = this.qualification.special_conditions;
    this.protocol_details = this.qualification.protocol_details;
    this.rights_to_work = this.qualification.rights_to_work;



    if (!this.waysToGetQualification.self_education.length) {
      this.waysToGetQualification.self_education = ['–'];
    }

    if (!this.waysToGetQualification.work_experience.length) {
      this.waysToGetQualification.work_experience = ['–'];
    }

    if (!this.waysToGetQualification.formal_education.length) {
      this.waysToGetQualification.formal_education = ['–'];
    }

    console.log('Rights: ' + this.rights_to_work.length);

    if (!this.rights_to_work.length) {
      this.rights_to_work = ['–'];
    }

    this.competences = this.qualification.competences;

  },
  created() {
    this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
  }
}
</script>

<style>

.info-list__textarea {
  overflow-y: hidden;
}

.info-list__textarea::placeholder {
  opacity: .5;
}

.related-job__item {
  border-radius: 0.8rem;
  border: 1px solid #e9ecf3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: calc(var(--spacer) * 4);
  padding: calc(var(--spacer) * 4);
  width: 100%;
}

.info-row {
  display: flex;
  margin: 0 -10px 24px;
}

.info-row .info-cell {
  margin: 0 10px;
}

.html-datepicker {
  width: 100%;
  padding: 4px 12px;
  border-radius: 0.8rem;
  border: 1px solid #c9d5f1;
  box-shadow: 0 0.8rem 1.6rem -0.2rem rgba(73, 129, 241, 0.08);
  display: inline-block;
  font-family: Roboto, sans-serif;
  height: 4.8rem;
  line-height: 4.8rem;
  outline: none;
}

.accordion-data-list__item--clickable {
  cursor: pointer;
  transition: .2s all ease-in-out;
}

.accordion-data-list__item--clickable:hover {
  color: #6a9bff;
}

fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
